<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="작업계획서 일정 관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <!-- <date-bar
            :firstDisplayDate="searchYear"
            :dateOnly="true"
            class="mx-1"
            label="조회년도"
            year
            full-width
            no-title
            @getDate="searchYearChanged"
          ></date-bar> -->
          <v-row no-gutters>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="searchStartYear"
                placeholder="시작년도"
                :menu="true"
                :dateOnly="true"
                :year="true"
                :allowMinDate="`2023-01-01`"
                :allowMaxDate="`${searchEndYear}-12-31`"
                @getDate="searchYearChanged($event, 'start')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1 mx-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="searchEndYear"
                placeholder="종료년도"
                :menu="true"
                :year="true"
                :dateOnly="true"
                :allowMinDate="`${searchStartYear}-01-01`"
                :allowMaxDate="`2035-01-01`"
                @getDate="searchYearChanged($event, 'end')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="mainGrid"
                  class="layout-col-height00"
                  width="100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :selection="{ mode: 'single' }"
                  key-expr="id"
                  :focused-row-enabled="true"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />
                  <DxColumn
                    data-field
                    data-type="string"
                    width="120px"
                    alignment="center"
                    caption
                    :allow-editing="false"
                    cell-template="actionTemplete"
                  ></DxColumn>

                  <template #header-cell-line-break="{ data }">
                    <div style="white-space: pre-line">
                      {{ data.column.caption }}
                    </div>
                  </template>
                  <template #actionTemplete="{ data: cellInfo }">
                    <div>
                      <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
                    </div>
                  </template>
                  <DxColumn
                    width="150px"
                    data-field="writeYear"
                    data-type="string"
                    alignment="center"
                    caption="작업계획년도"
                    :allow-editing="false"
                  />
                  <DxColumn
                    width="190px"
                    data-field="registMonthCnt"
                    data-type="string"
                    alignment="center"
                    :caption="`월별 작업일수 등록\n(입력 월/전체 월)`"
                    header-cell-template="header-cell-line-break"
                    cell-template="registMonthCntTemplate"
                    :allow-editing="false"
                  />
                  <template #registMonthCntTemplate="{ data: cellInfo }">
                    <div>
                      <span :style="{ color: getRegistMonthCntColor(cellInfo.data.registMonthCnt) }">{{
                        getRegistMonthCnt(cellInfo.data.registMonthCnt)
                      }}</span>
                    </div>
                  </template>
                  <DxColumn
                    width="150px"
                    data-field="registDayCnt"
                    data-type="string"
                    alignment="right"
                    :caption="`총 작업계획(일)`"
                    header-cell-template="header-cell-line-break"
                    :allow-editing="false"
                  />
                  <DxColumn
                    :visible="false"
                    width="130px"
                    data-field="totalWorkCnt"
                    data-type="string"
                    alignment="right"
                    :caption="`등록된 \n작업계획건수`"
                    header-cell-template="header-cell-header"
                    :allow-editing="false"
                    cell-template="registeredWorkDaysTemplate"
                  />
                  <template #header-cell-header="{ data }">
                    <div>
                      <div style="white-space: pre-line">
                        {{ data.column.caption }}
                      </div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ '숫자 클릭 시 월별 작업계획건수 현황을 볼 수 있습니다.' }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template #registeredWorkDaysTemplate="{ data: cellInfo }">
                    <a
                      @click="btnRegisteredWorkDays(cellInfo)"
                      style="transition: font-size 0.2s"
                      @mouseover="($event) => ($event.target.style.fontSize = '1.2em')"
                      @mouseleave="($event) => ($event.target.style.fontSize = '1em')"
                    >
                      {{ cellInfo.data.totalWorkCnt }}
                    </a>
                  </template>
                  <DxColumn width="140px" data-field="createdAt" data-type="string" alignment="center" :caption="`작성일자`" :allow-editing="false" />
                  <DxColumn width="120px" data-field="createdBy" data-type="string" alignment="center" :caption="`작성자`" :allow-editing="false" />
                  <DxColumn width="140px" data-field="updatedAt" data-type="string" alignment="center" :caption="`수정일자`" :allow-editing="false" />
                  <DxColumn width="120px" data-field="updatedBy" data-type="string" alignment="center" :caption="`수정자`" :allow-editing="false" />
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
        <!-- <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
          </v-navigation-drawer>
        </template>-->
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnAdd="btnAdd()"> </i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
    <i-dxpopup :popupVisible="popupVisible" :title="title" @popupCloseButtonClick="popupClose" height="450px" width="150px">
      <template v-slot:content>
        <v-row no-gutters class="template-btn-wrap">
          <SafetyWorkPlanMonthCard :planData="monthPlanData" />
        </v-row>
      </template>
    </i-dxpopup>
  </v-container>
</template>
<script>
// components
import iCardRight from '@/components/common/iCardRight.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iDxPopup from '@/components/common/iDxPopup.vue'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import SafetyWorkPlanMonthCard from './components/SafetyWorkPlanMonthCard.vue'
// utils
import { getCurrentDate, getPreMonth, getYearFormat } from '@/utils/common.js'
// api
import { getSafetyWorkPlanManageList, getSafetyWorkPlanManageMonth, cancelSelectedWorkPlan } from '@/api/riskAssessment/safetyWorkPlanManage.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'SafetyWorkPlanManage',
  components: {
    'i-card-vertical': iCardVertical,
    'i-dxpopup': iDxPopup,
    'i-date-time-picker': IDateTimePicker,
    iCardRight,
    SafetyWorkPlanMonthCard,
    // 절차서 컴포넌트
    // ProcedureComponent
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        // 'btnDelete', //삭제
      ],
      dxDataGridRef: 'mainGrid',
      gridMain: [],
      monthPlanData: [],
      allMode: 'allPages',
      popupVisible: false,
      title: '',
      searchStartYear: getYearFormat(getPreMonth(0)),
      searchEndYear: getYearFormat(getPreMonth(0)),
    }
  },
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  activated() {
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch(true)
    }
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  조회
    //------------------------------------------
    async btnSearch(notify = true) {
      // this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      this.openLoading('searching')
      const params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        searchStartYear: this.searchStartYear,
        searchEndYear: this.searchEndYear,
      }
      await getSafetyWorkPlanManageList(params, notify)
        .then((res) => {
          this.gridMain = res.list
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  추가
    //------------------------------------------

    btnAdd() {
      this.openLoading('searching')
      const toRouter = {
        name: 'SafetyWorkPlanManageDetail',
        params: {
          // data: cellInfo.data
          data: {
            clntId: this.getClntId(),
            compId: this.getCompId(),
            writeYear: getCurrentDate().substring(0, 4),
          },
        },
      }
      this.$router.push(toRouter)
      this.endLoading()
    },

    //------------------------------------------
    //  상세보기
    //------------------------------------------
    async btnDetail(cellInfo) {
      this.openLoading('searching')
      const toRouter = {
        name: 'SafetyWorkPlanManageDetail',
        params: {
          // data: cellInfo.data
          data: {
            clntId: cellInfo.data.clntId,
            compId: cellInfo.data.compId,
            writeYear: cellInfo.data.writeYear,
          },
        },
      }
      this.$router.push(toRouter)
      this.endLoading()
    },

    //------------------------------------------
    //  삭제
    //------------------------------------------
    // async btnDelete() {
    //   let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
    //   if (selectedRows.length === 0) {
    //     this.vSnackbar(this.$t('selectionData'), 'warn')
    //     return
    //   }
    //   let yearList = selectedRows.map((el) => el.writeYear)
    //   yearList = yearList.sort((a, b) => a - b)
    //   const yearListStr = yearList.join(', ')
    //   this.vToastifyPrompt(`${yearListStr}년 작업 계획서를 삭제하시겠습니까?`, 'info', async (current) => {
    //     this.openLoading()
    //     const deleteParams = []
    //     selectedRows.forEach((el) => {
    //       deleteParams.push({
    //         clntId: el.clntId,
    //         compId: el.compId,
    //         writeYear: el.writeYear,
    //       })
    //     })
    //     await cancelSelectedWorkPlan(deleteParams, true)
    //       .then((res) => {
    //         if (res.success) {
    //           this.btnSearch(false)
    //         }
    //       })
    //       .catch((err) => {
    //         this.endLoading()
    //       })
    //       .finally(() => {
    //         this.endLoading()
    //       })
    //   })
    // },

    searchYearChanged(e, div) {
      if (div == 'start') {
        this.searchStartYear = e.toString()
      } else {
        this.searchEndYear = e.toString()
      }
      this.btnSearch(true)
    },

    // 월별 작업일 수 등록 건수 출력
    getRegistMonthCnt(cnt) {
      let msg = ''
      if (cnt == 12) msg = `${cnt}/12(완료)`
      else msg = `${cnt}/12`
      return msg
    },
    // 월별 작업일 수 등록 건수 색상
    getRegistMonthCntColor(cnt) {
      let color = ''
      if (cnt == 12) color = '#1b53f3'
      else color = '#FF0000'
      return color
    },
    // 등록된 작업계획건수 셀 클릭 시 팝업 호출
    async btnRegisteredWorkDays(cellInfo) {
      this.openLoading('searching')
      const params = {
        clntId: cellInfo.data.clntId,
        compId: cellInfo.data.compId,
        writeYear: cellInfo.data.writeYear,
      }
      await getSafetyWorkPlanManageMonth(params)
        .then((res) => {
          console.log('#### res', res)
          if (res.success) {
            this.monthPlanData = res.list
            this.popupVisible = true
            this.title = `${cellInfo.data.writeYear}년 등록된 월별 작업계획건수`
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    popupClose() {
      this.popupVisible = false
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/theme/variables.scss';
.template-btn-wrap {
  padding: 0 24px;
  gap: 12px;
  flex-wrap: nowrap;
  .col-md-6,
  .col-12 {
    flex: unset !important;
  }
}
.template-btn {
  border-radius: 8px;
  border: 2px solid $card_border;
  background: $white;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;

  .btn-title {
    font-size: 1rem;
    font-weight: 600;
    line-height: normal;
    padding: 8px 0 24px;
  }
  .btn-desc {
    color: #808080;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: normal;
  }
  &:hover {
    border: 2px solid $primary;
    box-shadow: 0px 4px 8px 0px rgba(27, 83, 243, 0.15);
    .btn-title {
      font-size: 1rem;
      font-weight: 600;
      line-height: normal;
      color: $primary;
    }
  }
}
.tooltip-text {
  word-break: keep-all;
}
</style>
